// extracted by mini-css-extract-plugin
module.exports = {"messageBlock":"MessageInfo_messageBlock__3bPEd"};